import React from 'react';
import { Badge } from '../../../components/Badge';
import { Card } from '../../../components/Card';
import { Section } from '../../../components/Section';
import useTheme from '../../../hooks/useTheme';

export const PortalRoadmap: React.FC = () => {
  const { theme } = useTheme();
  const steps = [
    {
      number: 1,
      title: 'Launch Site',
      status: 'LIVE' as const,
      items: [
        'Public pages',
        'Events/news',
        'Partner info',
        'Contact',
      ],
    },
    {
      number: 2,
      title: 'Member Area',
      status: 'COMING SOON' as const,
      items: [
        'Member directory',
        'Event RSVP & attendance management',
        'Publications & briefings library',
      ],
    },
    {
      number: 3,
      title: 'Business Portal',
      status: 'COMING SOON' as const,
      items: [
        'Tenders database + alerts',
        'Business Opportunities Exchange',
        'Exclusive insights & reports',
        'Subscription plans',
      ],
    },
  ];

  return (
    <Section style={{ backgroundColor: theme.background.panel }}>
      <h2
        style={{
          fontSize: '34px',
          fontWeight: 700,
          color: theme.text.primary,
          marginBottom: '48px',
          textAlign: 'center',
        }}
        className="sectionTitle"
      >
        Portal Roadmap
      </h2>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '24px',
          position: 'relative',
        }}
        className="roadmapGrid"
      >
        {steps.map((step, idx) => (
          <Card key={idx} style={{ position: 'relative' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '20px',
              }}
            >
              <div
                style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: step.status === 'LIVE' ? theme.colors.green.g1 : theme.background.panel,
                  color: step.status === 'LIVE' ? theme.text.primary : theme.text.muted,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '24px',
                  fontWeight: 700,
                  border: step.status === 'LIVE' ? 'none' : `2px solid ${theme.colors.line}`,
                }}
              >
                {step.number}
              </div>
              <Badge status={step.status} />
            </div>

            <h3
              style={{
                fontSize: '22px',
                fontWeight: 600,
                color: theme.text.primary,
                marginBottom: '16px',
              }}
            >
              {step.title}
            </h3>

            <ul
              style={{
                listStyle: 'none',
                padding: 0,
                margin: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
              }}
            >
              {step.items.map((item, itemIdx) => (
                <li
                  key={itemIdx}
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '8px',
                    color: theme.text.muted,
                    fontSize: '14px',
                    lineHeight: 1.6,
                  }}
                >
                  <span
                    style={{
                      color: step.status === 'LIVE' ? theme.colors.green.g1 : theme.text.muted,
                      marginTop: '4px',
                      flexShrink: 0,
                    }}
                  >
                    {step.status === 'LIVE' ? '✓' : '○'}
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </Card>
        ))}
      </div>
    </Section>
  );
};

